import {ComponentTypesEnum} from '../../app/shared/enums/common';
import {BaseControl, CheckboxControl, SelectControl} from '../../app/shared/classes';

export interface SupervisedRightsFormInterface {
    supervisionId: BaseControl;
    nonSupervisedUsers: SelectControl;
    rights: CheckboxControl[];
}

export const SupervisedRightsIdSelector = 'supervisionId';
export const SupervisedRightsNonSupervisedUserSelector = 'nonSupervisedUserName';
export const SupervisedRightsArraySelector = 'supervisedRightsArray';
export const SupervisedRightsFormArraySelector = 'supervisedRightsFormArray';

export const SupervisedRightsRequiredErrorLabel = 'At least one permission';
export const SupervisedRightsInvalidErrorLabel = 'rights';

export const SupervisedRightsFormItems = (): SupervisedRightsFormInterface => {
    return {
        supervisionId: new BaseControl({
            name: SupervisedRightsIdSelector,
            value: null,
            placeholder: '',
            validators: [],
            componentType: ComponentTypesEnum.Text
        }),
        nonSupervisedUsers: new SelectControl({
            name: SupervisedRightsNonSupervisedUserSelector,
            value: null,
            placeholder: 'Client',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        rights: []
    };
};
